/**
 * Длина результата → скорость (/speed): набрать «2:00» — и файл выйдет ровно 2:00.
 *
 * Чистые функции, без DOM: страница даёт модель длины, модуль отвечает числом.
 * Модель — та же, что пишет файл: G — секунды исходника на ОБЩЕЙ скорости,
 * R — секунды результата, которые дают участки со своей скоростью; длина
 * результата = R + G / скорость. Отсюда решение одно: скорость = G / (T − R).
 *
 * Ступени вердикта — замер, а не вкус (08.10.2026):
 *   • заметность темпа: разницу в темпе музыки слышат от 3–6 % при прямом
 *     сравнении, а темп знакомой песни помнят с точностью ±8 % (Levitin & Cook,
 *     1996, Perception & Psychophysics 58:927) — отсюда QUIET 3 % и NEAR 8 %;
 *   • артефакты движка музыки (вокодер), Audiobox PQ против исходника, 34 песни
 *     × 11 скоростей: ускорение до ×1.35 — в пределах −0.03, ×1.5 — −0.06,
 *     ×1.67 — −0.12; замедление дороже: ×0.98 — −0.05, ×0.95 — −0.06,
 *     ×0.9 — −0.08, ×0.8 — −0.16. «Звук размывается» говорится там, где средняя
 *     потеря ≥ 0.06: ×0.9 и медленнее, ×1.5 и быстрее.
 * Разбор — docs/why/speed-target-length.md.
 */
(function (root) {
    'use strict';

    var QUIET = 0.03, NEAR = 0.08, SMEAR_SLOW = 0.9, SMEAR_FAST = 1.5;

    /* м:сс, десятые — только у нецелой длины. Вниз до десятой (с допуском
       полмиллисекунды): плееры показывают целые секунды отбрасыванием, и
       обещать «2:00» за 1:59,96 нельзя — это «1:59.9». */
    function fmtLen(s) {
        if (!isFinite(s) || s < 0) s = 0;
        var t = Math.floor((s + 0.0005) * 10) / 10;
        var m = Math.floor(t / 60), sec = Math.round((t - m * 60) * 10) / 10;
        var whole = Math.abs(sec - Math.round(sec)) < 1e-9;
        return m + ':' + (sec < 10 ? '0' : '') + (whole ? String(Math.round(sec)) : sec.toFixed(1));
    }

    /* Скорость под длину T. Нет общей части — длину задают одни участки;
       участки сами не короче цели — короче не получится, пока они такие. */
    function solve(parts, T) {
        if (!parts) return { outcome: 'nofile' };
        if (!(parts.G > 1e-6)) return { outcome: 'all_regions', R: parts.R };
        if (!(T > parts.R + 0.05)) return { outcome: 'regions_longer', R: parts.R };
        return { outcome: 'ok', rate: parts.G / (T - parts.R), R: parts.R };
    }

    function reachable(s, floor, ceil) {
        return s.outcome === 'ok' && s.rate >= floor - 1e-9 && s.rate <= ceil + 1e-9;
    }

    /* Голая цифра — минуты, когда секунды невозможны, а минуты возможны.
       Замер поля цели /extend-song (179 сессий с 29.09.2026): из 18 вводов одной
       цифрой 9 тут же переписаны в «м:сс»; двузначные («45», «90») переписаны
       4 из 21 — это чаще секунды. Поэтому одна-две цифры и только там, где
       секундами длина физически не получается. */
    function interpret(raw, T, parts, floor, ceil) {
        if (/^\d{1,2}$/.test(String(raw == null ? '' : raw).trim())) {
            if (!reachable(solve(parts, T), floor, ceil) && reachable(solve(parts, T * 60), floor, ceil)) {
                return { T: T * 60, mins: true };
            }
        }
        return { T: T, mins: false };
    }

    /* Что человек услышит при этой скорости. */
    function verdict(rate) {
        var a = Math.abs(rate - 1);
        if (a < 0.0005) return null;
        // Допуск: 1.03 − 1 в плавающей точке — 0.0300000000000000266.
        var quiet = a <= QUIET + 1e-9, near = a <= NEAR + 1e-9;
        var key = quiet ? 'len_tempo_quiet' : near ? 'len_tempo_near' : (rate > 1 ? 'len_tempo_faster' : 'len_tempo_slower');
        return {
            key: key,
            level: near ? 'ok' : 'warn',
            smear: rate <= SMEAR_SLOW + 1e-9 || rate >= SMEAR_FAST - 1e-9,
            noticeable: !near,
        };
    }

    var api = { fmtLen: fmtLen, solve: solve, reachable: reachable, interpret: interpret, verdict: verdict,
        QUIET: QUIET, NEAR: NEAR, SMEAR_SLOW: SMEAR_SLOW, SMEAR_FAST: SMEAR_FAST };
    root.SpeedTargetLength = api;
    if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);
